import { treaty } from '@elysiajs/eden';
import type { App } from '../../../backend3/src/server_elysia';
import { API_ROOT_URL } from '../config';

// Create the Eden Treaty client
// We use API_ROOT_URL because treaty handles the path structure automatically based on Elysia routes
// @ts-ignore - Conflicto nominal en monorepo
export const client = treaty<App>(API_ROOT_URL);

/**
 * Example usage:
 * const { data, error } = await api.user.profile.get();
 */
